// Days
export const ONE_DAY_TIME = 24 * 60 * 60 * 1000;
export const SEVEN_DAYS_TIME = 7 * 24 * 60 * 60 * 1000;
export const THIRTY_DAYS_TIME = 30 * 24 * 60 * 60 * 1000;

// Seconds
export const TWO_SECONDS_TIMEOUT = 2000;
export const FIVE_SECONDS_TIMEOUT = 5000;
export const ONE_MINUTE_TIMEOUT = 1000 * 60;

// Hours
export const ONE_HOUR_IN_MS = 60 * 60 * 1000;

/**
 * How long a chat attachment is treated as still readable.
 *
 * `cleanup-chat-uploads` deletes objects older than 24h, but it runs on the hour
 * (`0 * * * *`), so a file can outlive its own 24h by up to 59 minutes. The extra
 * hour of slack keeps the UI from calling a file expired while it is in fact
 * still downloadable — the error is deliberately biased towards showing a live
 * link a little longer, never towards offering a dead one.
 *
 * This is a proxy for the file's real state, not a lookup: nothing here asks
 * Storage whether the object exists.
 */
export const CHAT_FILE_EXPIRY_MS = 25 * 60 * 60 * 1000;
